/**
 * Message Image Source
 *
 * Normalizes image sources before they leave local preview state.
 *
 * Primary responsibilities:
 * - Detect browser-only blob preview URLs
 * - Choose model-safe image URLs or storage paths
 *
 * Dependencies:
 * - None
 */

// --------------

export function isBlobPreviewUrl(value: unknown) {
  return typeof value === 'string' && /^blob:/i.test(value.trim())
}

// --------------

export function getNonBlobImageSource(value: unknown) {
  if (typeof value !== 'string') {
    return null
  }

  const source = value.trim()

  if (!source || isBlobPreviewUrl(source)) {
    return null
  }

  return source
}
